import {NgModule} from '@angular/core';
import {OnlyNumberDirective} from './only-number.directive';
import {NumericDecimalDirective} from './only-number-decimal.directive';
import {RangeDirective} from './range.directive';
import {NotAllowDotDirective} from './not-allow-dot-directive';

@NgModule({

    declarations: [OnlyNumberDirective, NumericDecimalDirective, RangeDirective, NotAllowDotDirective],
    exports: [OnlyNumberDirective, NumericDecimalDirective, RangeDirective, NotAllowDotDirective]

})

export class NumberAcceptModule {
}
